/**
 * Poster Preview Zoom Modal
 * Click the poster preview to open a fullscreen modal showing an enlarged version.
 * Clones the actual poster DOM for pixel-perfect accuracy.
 */
(function() {
  'use strict';

  var ZOOM_MIN = 0.8;
  var ZOOM_MAX = 3;
  var ZOOM_STEP = 0.5;
  var zoom = 1;
  var panX = 0;
  var panY = 0;
  var isDragging = false;
  var dragStartX = 0;
  var dragStartY = 0;
  var panStartX = 0;
  var panStartY = 0;
  var touchState = { active: false, startDist: 0, startZoom: 1 };

  // Create modal
  var modalHtml = '<div class="pp-zoom-modal" id="pp-zoom-modal" style="display:none">' +
    '<div class="pp-zoom-modal__backdrop"></div>' +
    '<div class="pp-zoom-modal__content" id="pp-zoom-content"></div>' +
    '<div class="pp-zoom-modal__controls">' +
      '<button type="button" class="pp-zoom-modal__btn" id="pp-zoom-out">&#8722;</button>' +
      '<span class="pp-zoom-modal__level" id="pp-zoom-level">100%</span>' +
      '<button type="button" class="pp-zoom-modal__btn" id="pp-zoom-in">&#43;</button>' +
      '<span class="pp-zoom-modal__divider"></span>' +
      '<button type="button" class="pp-zoom-modal__btn pp-zoom-modal__btn--close" id="pp-zoom-close">&times;</button>' +
    '</div>' +
  '</div>';

  $(document.body).append(modalHtml);

  var $modal = $('#pp-zoom-modal');
  var $content = $('#pp-zoom-content');
  var $level = $('#pp-zoom-level');

  function applyTransform() {
    $content.css('transform', 'scale(' + zoom + ') translate(' + panX + 'px, ' + panY + 'px)');
    $level.text(Math.round(zoom * 100) + '%');
    $('#pp-zoom-in').prop('disabled', zoom >= ZOOM_MAX);
    $('#pp-zoom-out').prop('disabled', zoom <= ZOOM_MIN);
    $content.css('cursor', zoom > 1 ? 'grab' : 'default');
  }

  function constrainPan() {
    if (zoom <= 1) { panX = 0; panY = 0; return; }
    var maxPan = 150 * (zoom - 1);
    panX = Math.min(maxPan, Math.max(-maxPan, panX));
    panY = Math.min(maxPan, Math.max(-maxPan, panY));
  }

  function resetZoom() {
    zoom = 1;
    panX = 0;
    panY = 0;
    applyTransform();
  }

  function setZoom(newZoom) {
    zoom = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(newZoom * 10) / 10));
    constrainPan();
    applyTransform();
  }

  function openModal() {
    // Find the visible poster preview
    var $source = $('.petposter-template:not(.hidden-preview) .bp-poster-preview, .photoposter-section .bp-poster-preview').first();
    if (!$source.length) return;

    // Clone the poster preview into the modal
    var $clone = $source.clone();
    $clone.addClass('pp-zoom-clone');
    // Remove any zoom hints from clone
    $clone.find('.bp-zoom-controls').remove();
    // Drop the ring of frame colour the preview carries behind its border
    // image (see pp-canvas-3d.js). In here the frame is drawn the ordinary
    // way, so nothing covers the ring and it reads as a flat band of oak
    // round the whole picture — and being inline it also beat this modal's
    // own drop shadow.
    $clone.css('box-shadow', '');

    $content.empty().append($clone);
    resetZoom();
    $modal.fadeIn(200);
    document.body.style.overflow = 'hidden';
    document.body.classList.add('pp-zoom-active');
  }

  function closeModal() {
    $modal.fadeOut(200, function() {
      document.body.style.overflow = '';
      document.body.classList.remove('pp-zoom-active');
      $content.empty();
    });
  }

  // --- Open on click ---
  $(document).on('click', '.bp-poster-preview-cont', function(e) {
    if ($(e.target).closest('button, a, input, select, .ptp-toolbar, .bp-upload-overlay, .bp-ai-generating-overlay').length) return;
    if ($(this).closest('.hidden-preview').length) return;
    if ($(this).closest('.ptp-adjusting').length) return;
    openModal();
  });

  // --- Disable right-click on zoom modal ---
  $modal.on('contextmenu', function(e) { e.preventDefault(); });

  // --- Close ---
  $(document).on('click', '#pp-zoom-close, .pp-zoom-modal__backdrop', closeModal);
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $modal.is(':visible')) closeModal();
  });

  // --- Zoom buttons ---
  $(document).on('click', '#pp-zoom-in', function() { setZoom(zoom + ZOOM_STEP); });
  $(document).on('click', '#pp-zoom-out', function() { setZoom(zoom - ZOOM_STEP); });

  // --- Scroll wheel ---
  $content.on('wheel', function(e) {
    e.preventDefault();
    setZoom(zoom + (e.originalEvent.deltaY < 0 ? 0.25 : -0.25));
  });

  // --- Drag to pan ---
  $content.on('mousedown', function(e) {
    if (zoom <= 1) return;
    isDragging = true;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    panStartX = panX;
    panStartY = panY;
    $content.css('cursor', 'grabbing');
    e.preventDefault();
  });

  $(document).on('mousemove', function(e) {
    if (!isDragging) return;
    panX = panStartX + (e.clientX - dragStartX) / zoom;
    panY = panStartY + (e.clientY - dragStartY) / zoom;
    constrainPan();
    applyTransform();
  });

  $(document).on('mouseup', function() {
    if (isDragging) {
      isDragging = false;
      $content.css('cursor', zoom > 1 ? 'grab' : 'default');
    }
  });

  // --- Touch ---
  function getTouchDist(t) {
    var dx = t[0].clientX - t[1].clientX;
    var dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  $content.on('touchstart', function(e) {
    var touches = e.originalEvent.touches;
    if (touches.length === 2) {
      e.preventDefault();
      touchState.active = true;
      touchState.startDist = getTouchDist(touches);
      touchState.startZoom = zoom;
    } else if (touches.length === 1 && zoom > 1) {
      e.preventDefault();
      isDragging = true;
      dragStartX = touches[0].clientX;
      dragStartY = touches[0].clientY;
      panStartX = panX;
      panStartY = panY;
    }
  });

  $content.on('touchmove', function(e) {
    var touches = e.originalEvent.touches;
    if (touches.length === 2 && touchState.active) {
      e.preventDefault();
      setZoom(touchState.startZoom * (getTouchDist(touches) / touchState.startDist));
    } else if (touches.length === 1 && isDragging && zoom > 1) {
      e.preventDefault();
      panX = panStartX + (touches[0].clientX - dragStartX) / zoom;
      panY = panStartY + (touches[0].clientY - dragStartY) / zoom;
      constrainPan();
      applyTransform();
    }
  });

  $content.on('touchend touchcancel', function() {
    isDragging = false;
    touchState.active = false;
  });

  // Double tap
  var lastTap = 0;
  $content.on('touchend', function(e) {
    var now = Date.now();
    if (now - lastTap < 300) {
      e.preventDefault();
      if (zoom > 1) resetZoom(); else setZoom(2);
    }
    lastTap = now;
  });

})();
